import { AZURE_URL } from "../constants/env-constants";

export const getAllLocations = async () => {
  try {
    const response = await AZURE_URL.get("/location/get/all");
    if (response.status === 200) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return [null, error.response];
  }
};

export const createNewLocation = async (data: CreateLocationRequest) => {
  try {
    const response = await AZURE_URL.post("/location/create", data);
    if (response?.status >= 200 && response.status < 300) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return [null, error.response.data];
  }
};

export const updateLocation = async (data: UpdateLocationRequest) => {
  try {
    const response = await AZURE_URL.put("/location/update", data);
    if (response?.status >= 200 && response.status < 300) {
      return [response.data, null];
    } else if (response?.status >= 400 && response.status < 600) {
      return [null, response.data];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return [null, error.response];
  }
};

export const deleteLocation = async (id: string) => {
  try {
    const response = await AZURE_URL.delete(`/location/delete?publicId=${id}`);
    console.log(response);
    if (response.status === 200) {
      return [response, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    console.log(error);
    return [null, "Server Error: " + error.message];
  }
};
